import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizDataTable } = component_tool
const { WizContainer, ossFileUtils } = framework_tool
const { getPageData } = utils_tool

class Download extends WizContainer {

    componentName = 'Download'

    constructor(props) {
        super(props)
        this.state = {
            fileId: undefined
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = (params = {}) => {
        const { record = {} } = this.props
        this.doAction({
            path: 'preAudit/downloadList',
            payload: {
                key: 'downloadList@' + record.id,
                apiParams: {
                    auditBaseId: record.id,
                    ...params
                }
            }
        })
    }

    propsAndStateOnChange = {
        file: this._fileOnChange.bind(this)
    }

    _fileOnChange(nextProps, nextState) {
        if (nextProps.file && nextProps.file.code === 1) {
            let { fileUri, fileOriginalName } = nextProps.file.data
            let url = ossFileUtils.getOssUrlBySuffix(fileUri)
            this._getBlob(url, (blob) => {
                this._saveAs(blob, fileOriginalName)
                wizNotice.success('操作成功')
                this.props.changeModal(false)
            })
        } else {
            wizNotice.error(nextProps.file.msg)
        }
        return true
    }

    _getBlob(url, cb) {
        let xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = function () {
            if (xhr.status === 200) {
                cb(xhr.response)
            }
        }
        xhr.send()
    }

    _saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename)
        } else {
            let link = document.createElement('a')
            let body = document.querySelector('body')

            link.href = window.URL.createObjectURL(blob)
            link.download = filename

            // fix Firefox
            link.style.display = 'none'
            body.appendChild(link)

            link.click()
            body.removeChild(link)

            window.URL.revokeObjectURL(link.href)
        }
    }

    _ok = () => {
        let { fileId } = this.state
        if(!fileId){
            wizNotice.warn("请先选择需下载的文件");
            return;
        }
        this.doAction({
            path: 'ossUpload/getFileInfoByFileId',
            payload: {
                key: 'preAuditDownloadFile',
                apiParams: {
                    fileId
                }
            }
        })
    }

    render() {
        let columns = [{
            title: '上传人',
            name: 'uploadFullName',
            dataIndex: 'uploadFullName',
            tableItem: {}
        }, {
            title: '上传时间',
            name: 'uploadTime',
            dataIndex: 'uploadTime',
            tableItem: {}
        }, {
            title: '版本序号',
            name: 'version',
            dataIndex: 'version',
            tableItem: {}
        }]
        let dataItems = getPageData(this.props.list.data)
        let tableProps = {
            columns,
            dataItems,
            rowKey: 'id',
            selectType: 'radio',
            isScroll: true,
            scroll: { y: 420 },
            onChange: ({ pageNum, pageSize }) => this._list({ current: pageNum, size: pageSize }),
            onSelect: (keys, rows) => {
                let row = rows[0]
                this.setState({ fileId: row.fileId })
            }
        }
        return (
            <>
                <WizDataTable {...tableProps} />
                <div className='pagination'>
                    <WizDataTable.Pagination showLessItems size='small' {...tableProps} />
                </div>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { preAudit, ossUpload } = state
    const list = modelUtils.getModelEntity(preAudit, 'downloadList@' + ownProps.record.id)
    const file = modelUtils.getModelEntity(ossUpload, 'preAuditDownloadFile')
    return {
        list,
        file
    }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Download)


